// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"wf_a bhj_b bhj_ux"};